
import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';
import PropTypes from 'prop-types';
import { Widgets } from '@mui/icons-material';

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 60;
const SIDEBAR_WIDTH = 280; // Full width when expanded
const SIDEBAR_COLLAPSED_WIDTH = 88; // Width when collapsed

const RootStyle = styled('div')({
  display: 'flex',
  height: '100vh',
  overflow: 'hidden',
  backgroundColor: 'background.default',
});

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  height: '100vh',
  overflow: 'hidden',
  paddingTop: APP_BAR_MOBILE,
  backgroundColor: 'background.default',
  transition: 'margin-left 0.3s',
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP,
    marginLeft: localStorage.getItem('sidebarCollapsed') === 'true' ? 22 : 0
  }
}));

const ContentScroll = styled(Box)(({ theme }) => ({
  height: '100%',
  overflowY: 'auto',
  overflowX: 'hidden',
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.15)' : 'rgba(15,23,42,0.18)'} transparent`,
  '&::-webkit-scrollbar': {
    width: 4,
    height: 4,
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.15)' : 'rgba(15,23,42,0.18)',
    borderRadius: 4,
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.24)' : 'rgba(15,23,42,0.28)',
  },
  paddingTop: theme.spacing(3),
  paddingBottom: 0,
  [theme.breakpoints.up('lg')]: {
    paddingLeft: 0,
    paddingRight: 0,
  },
}));




export default function DashboardLayout({ setToken, setUserType, userType, userData }) {
  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    document.documentElement.style.setProperty(
      '--sidebar-width',
      isCollapsed ? `${SIDEBAR_COLLAPSED_WIDTH}px` : `${SIDEBAR_WIDTH}px`
    );
  }, [isCollapsed]);

  return (
    <RootStyle>
      <DashboardNavbar onOpenSidebar={() => setIsCollapsed(false)} setToken={setToken} setUserType={setUserType} userData={userData} />
      <DashboardSidebar
        isCollapsed={isCollapsed}
        onToggle={() => setIsCollapsed((v) => !v)}
        userType={userType}
        userData={userData}
      />
      <MainStyle isSidebarCollapsed={isCollapsed}>
        <ContentScroll>
          <Outlet />
        </ContentScroll>
      </MainStyle>
    </RootStyle>
  );
}

DashboardLayout.propTypes = {
  setToken: PropTypes.func.isRequired,
  setUserType: PropTypes.func,
  userType: PropTypes.number,
  userData: PropTypes.object
};
